import { useState } from 'react'

import styles from './Tooltip.module.css';

function Tooltip({ children, text, position = 'top' }) {
    const [isVisible, setIsVisible] = useState(false)

    const showTooltip = () => setIsVisible(true)
    const hideTooltip = () => setIsVisible(false)
    
    return (
        <div  className={styles.tooltipContainer}>
            <div tabIndex="0"
                onMouseEnter={showTooltip}
                onMouseLeave={hideTooltip}
                onFocus={showTooltip}
                onBlur={hideTooltip}
                aria-describedby={isVisible ? 'tooltip' : undefined}
            >
                {children}
            </div>
            {isVisible && (
                <div
                    id="tooltip"
                    role="tooltip"
                    className={styles.tooltipActual}

                // className={`tooltip tooltip-${position}`}
                >
                    {text}
                </div>
            )}
        </div>
    )
}

export default Tooltip;
